/*
 * Title: pages/Touchpoints.tsx
 * Author: Chris Rosa
 * Email: chris@encore.fans
 * Description: import Touchpoints component form containers.
 * Date: 12 Sep 2022
 * Copyright (c) Encore, 2022
 * Version:0.1.0
 */

import * as React from "react";
import { useSelector } from "react-redux";
import Touchpoint  from "@services/touchpoint-service";
import Touchpoints from "@containers/creator/Touchpoints";

type Props = {
  name: string;
};

const TouchpointsPage: React.FC<Props> = props => {
  const program = useSelector((state: any) => (state.user?.user?.user?.programs?.[0] || {}));

  React.useEffect(()=>{
    
    if(program?.id){
      Touchpoint.fetch(program?.id);
    }
  }, []);

  return <Touchpoints />;
};

export default TouchpointsPage;
